// Keep mobile product videos inside the visible gallery frame.
(function () {
  var STYLE_ID = 'nomitail-product-video-mobile-frame-fix-style';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media(max-width:749px){',
      '.product-media-container--video{position:relative!important;background:#000!important;overflow:hidden!important;}',
      '.product-media-container--video>.product-media-constraint-wrapper,',
      '.product-media-container--video>.product-media-constraint-wrapper>.product-media{width:100%!important;height:100%!important;min-height:0!important;max-height:100%!important;aspect-ratio:inherit!important;}',
      '.product-media-container--video .product-media>video{height:100%!important;max-height:100%!important;object-fit:contain!important;}',
      '}',
    ].join('');

    document.head.appendChild(style);
    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyles);
  } else {
    injectStyles();
  }
})();
